/**
 * A map type whose key and value must match. The type parameter U should be a string union type.
 * This is useful when defining "enums" to use at runtime based on string union types,
 * since declaring the source type as a string union allows this type safety for the enum mapping,
 * as well as allowing types to be extended from one another.
 */
export type StringUnionKeyAsValue<U extends string> = Readonly<{
  [K in U]: K
}>;

/**
 * Use in the default clause of a switch statement for a compile-time check that all the cases have been covered
 */
export function assertUnreachable(_: never) {
  return;
}
